module.exports = __webpack_public_path__ + "img/lieutenantTroop.695e8030.png";